import axios from "axios";
import React, { useState, useEffect } from "react";
import Modal from "react-modal";

const customStyles = {
  content: {
    display: "flex",
    alignItems: "flexStart",
    justifyContent: "center",
    width: "350px",
    // height: "42rem",
    // background: "lightBlue",
    overflowY: "hidden",
    boxShadow: "0px 10px 8px rgba(0,0,0,0.2)",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    padding: "0 0 10px 0",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.6)",
  },
};

const EditAssetModal = ({
  showEditModal,
  setShowEditModal,
  updateStatus,
  Asset,
}) => {
  const token = localStorage.getItem("token");
  const config = {
    headers: { Authorization: `${token}` },
  };

  const [interestRate, setInterestRate] = useState(Asset?.interest_rate);
  const [ltv, setLTV] = useState(Asset?.ltv);
  //   const [tenure, setTenure] = useState([]);
  //   console.log(tenure);

  useEffect(() => {
    setInterestRate(Asset.interest_rate);
    setLTV(Asset.ltv);
    setTenureListForEdit(Asset?.tenure);
  }, [Asset]);

  const [tenureListForEdit, setTenureListForEdit] = useState([]);
  //   console.log(tenureListForEdit);
  const [activeMonth, setActiveMonth] = useState(
    tenureListForEdit?.map(() => false)
  );
  //   console.log(activeMonth);
  const [isDiabledUser, setIsDiabledUser] = useState(true);
  const [responseMsgUser, setResponseMsgUser] = useState("  ");

  const [monthAddInput, setMonthAddInput] = useState("");

  useEffect(() => {
    if (interestRate || ltv || tenureListForEdit?.length > 0) {
      setIsDiabledUser(false);
    } else setIsDiabledUser(true);
  }, [interestRate, ltv]);

  const handleUserClick = (e) => {
    e.preventDefault();
    updateStatus(Asset.id, Asset.status, tenureListForEdit, interestRate, ltv);
  };

  const handleActiveMonthChange = (month, index) => {
    const temArrMonth = [...activeMonth];
    temArrMonth[index] = month;
    setActiveMonth(temArrMonth);
  };

  const handleRemoveMonth = (index) => {
    const updatedTenureList = [...tenureListForEdit];
    updatedTenureList.splice(index, 1);
    setTenureListForEdit(updatedTenureList);
    setActiveMonth(updatedTenureList.map(() => false));
  };

  const handleAddMonth = () => {
    if (tenureListForEdit.includes(Number(monthAddInput))) {
      setResponseMsgUser("Month already exists");
      return;
    }
    if (monthAddInput !== "" && monthAddInput <= 12 && monthAddInput >= 1) {
      const temArr = [...tenureListForEdit];
      temArr.push(Number(monthAddInput));
      temArr.sort((a, b) => a - b);
      setTenureListForEdit(temArr);
      //   setTenureListForEdit([...tenureListForEdit, Number(monthAddInput)]);
    } else {
      setResponseMsgUser(
        "The valid range for the additional month should be between 1 and 12."
      );
    }
  };

  return (
    <Modal isOpen={showEditModal} style={customStyles}>
      <div className="addEmployer-container">
        <form>
          <h1>Edit Asset</h1>
          <div className="password-input-container">
            <p style={{ fontSize: "14px" }}>Interest rate (%)</p>
            <div className="password-input-div">
              <input
                type="text"
                placeholder="Interest Rate"
                value={interestRate}
                onChange={(e) => setInterestRate(e.target.value)}
                // value={userMail}
                required
              />
            </div>
            <p style={{ fontSize: "14px" }}>LTV (%)</p>
            <div className="password-input-div">
              <input
                type="text"
                placeholder="LTV"
                value={ltv}
                onChange={(e) => setLTV(e.target.value)}
                // value={userMail}
                required
              />
            </div>
            <div className="tenure-container">
              <p>Tenure</p>
              <span className="text-xs">(in months)</span>
              {/* <label className="tenure-label">
                <input
                  type="checkbox"
                  placeholder="Tenure"
                  style={{ width: "13px" }}
                  onChange={(e) => handleTenureAdd("3", e.target.checked)}
                  // value={tenure}
                />
                3 months
              </label>
              <label className="tenure-label">
                <input
                  type="checkbox"
                  placeholder="Tenure"
                  style={{ width: "13px" }}
                  onChange={(e) => handleTenureAdd("6", e.target.checked)}
                  // value={tenure}
                />
                6 months
              </label>
              <label className="tenure-label">
                <input
                  type="checkbox"
                  placeholder="Tenure"
                  style={{ width: "13px" }}
                  onChange={(e) => handleTenureAdd("9", e.target.checked)}
                  // value={tenure}
                />
                9 months
              </label>
              <label className="tenure-label">
                <input
                  type="checkbox"
                  placeholder="Tenure"
                  style={{ width: "13px" }}
                  onChange={(e) => handleTenureAdd("12", e.target.checked)}
                  // value={tenure}
                />
                12 months
              </label>
              <label className="tenure-label">
                Other:
                <input
                  type="text"
                  placeholder="18, 24, ..."
                  style={{
                    backgroundColor: "white",
                    borderBottom: "1px solid black",
                    outline: "none",
                  }}
                  onChange={handleTenureAdd}
                  // value={tenure}
                />
              </label> */}
              <div style={{ display: "flex", marginTop: "10px" }}>
                {tenureListForEdit?.map((t, index) => (
                  <p
                    onClick={() => handleRemoveMonth(index)}
                    className="circle-button"
                    onMouseEnter={() => handleActiveMonthChange(true, index)}
                    onMouseLeave={() => handleActiveMonthChange(false, index)}
                  >
                    {activeMonth[index] ? "x" : t}
                  </p>
                ))}
              </div>
              <label className="tenure-label">
                <input
                  type="text"
                  placeholder="6"
                  style={{
                    backgroundColor: "white",
                    borderBottom: "1px solid black",
                    outline: "none",
                    width: "40px",
                  }}
                  onChange={(e) => {
                    setMonthAddInput(e.target.value);
                    setResponseMsgUser("");
                  }}
                />
                <p
                  style={{ cursor: "pointer", marginTop: "10px" }}
                  onClick={handleAddMonth}
                >
                  Add
                </p>
              </label>
            </div>
          </div>
          <p className="text-sm text-red-600 mt-3">{responseMsgUser}</p>
          <button
            className="password-save-btn"
            onClick={(e) => handleUserClick(e)}
            disabled={isDiabledUser}
            style={
              isDiabledUser
                ? { backgroundColor: "gray", cursor: "default" }
                : {}
            }
          >
            Save Changes
          </button>
          <button
            className="password-cancel-btn"
            onClick={() => setShowEditModal(false)}
          >
            Cancel
          </button>
        </form>
      </div>
    </Modal>
  );
};

export default EditAssetModal;
